import { POST_MESSAGE, PROMISE_MESSAGE } from '../constants/message'
import { snakeToCamelCase } from './index'
/**
 * 传递格式：
 * {
 *      action: "REFRESH_LIST",
 *      data: {
 *          a: 1
 *      }
 * }
 */
const messageMap = new Map()
const fnMap = new Map()

window.addEventListener('message', function (e) {
  if (e.origin !== process.env.VUE_APP_IFRAME_DOMAIN) {
    // return
  }
  if (e.data.action && messageMap.get(e.data.action)) {
    messageMap.get(e.data.action)(e.data.data)
  }
}, false)

const postMessage = (action) => (data) => {
  const message = {
    action,
    data
  }
  window.parent.postMessage(message, '*')
}
export const postMessagePromise = (action, data) => {
  const id = crypto.randomUUID()
  const message = {
    action: PROMISE_MESSAGE,
    data: {
      id: id,
      action,
      data
    }
  }
  return new Promise((resolve, reject) => {
    window.parent.postMessage(message, '*')
    fnMap.set(id, resolve)
  })
}
const messageFn = {}

function genMessage () {
  for (let messageName in POST_MESSAGE) {
    let fnName = snakeToCamelCase(messageName)
    messageFn[fnName] = postMessage(POST_MESSAGE[messageName])
  }
}

genMessage()

export const receiveMessage = (action, callback) => {
  messageMap.set(action, callback)
}

export const receivePromiseMessage = (id, data) => {
  const fn = fnMap.get(id)
  if (typeof fn === 'function') {
    fn(data)
  }
}

export default messageFn
